import type { Event } from "@circle-react/types";
import { PEOPLE_TABS } from "../../../utils";
import { Attendees } from "../Attendees";
import { Cohosts } from "../Cohosts";

interface Tab {
  key: string;
  label: string;
}

interface PeopleBodyProps {
  currentTab?: Tab;
  event: Event;
}

export const PeopleBody = ({ event, currentTab }: PeopleBodyProps) => {
  switch (currentTab?.key) {
    case PEOPLE_TABS.COHOSTS:
      return <Cohosts event={event} />;
    case PEOPLE_TABS.ATTENDEES:
    default:
      return <Attendees event={event} />;
  }
};
